import axios from "../../config/axiosConfig";
import { RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST, RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST_FAILURE, GET_RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTIONS_TAKA_NO,
  GET_RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTIONS } from "../types";

export const getRawMaterialIssueChallanTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/raw-material-issue-challan-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getRawMaterialIssueChallanTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/raw-material-issue-challan-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

